/**
 * Created by shuhin on 05/16/20.
 */
import React from "react";
import { connect } from "react-redux";
import api from "../../utility/api";
import PaymentUpdateForm from "./manual-payment-form.component";
import { asyncStart, asyncEnd, showFeedback } from "../../actions/application";

class ManualPaymentContainer extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      amount: "",
      medium: "",
      fromPhone: "",
      notes: "",
    };
  }

  dispatch(action) {
    this.props.dispatch(action());
  }

  displayFeedBack(message) {
    this.props.dispatch(showFeedback({ message: message }));
  }

  handleChange(field, e) {
    this.setState({ [field]: e.target.value });
  }

  handleSelect(field, e) {
    this.setState({ [field]: e.target.value });
  }

  handleSubmit(e) {
    e.preventDefault();

    let { amount, medium, fromPhone, notes } = this.state;

    if (!amount) {
      this.displayFeedBack("Please give an amount.");
      return;
    }
    if (amount < 0 || amount > 10000 ) {
      this.displayFeedBack("Invalid amount, Please enter a valid amount!");
      return;
    }
    if (!medium) {
      this.displayFeedBack("Please select a medium.");
      return;
    }

    let missionId = this.props.mission.id;

    this.dispatch(asyncStart);
    api
      .manualPayment(missionId, amount, medium, fromPhone, notes)
      .then((response) => {
        this.dispatch(asyncEnd);
        this.props.toggleManualPaymentDialog();
        this.displayFeedBack(
          `Payment have been updated successfully with due amount: ${response.dueAmount}`
        );
      })
      .catch((error) => {
        this.dispatch(asyncEnd);
        this.displayFeedBack(error.message);
        this.props.toggleManualPaymentDialog();
      });
  }

  render() {
    let { amount, medium, fromPhone, notes } = this.state;
    let { toggleManualPaymentDialog, mission } = this.props;

    return (
      <PaymentUpdateForm
        mission={mission}
        amount={amount}
        medium={medium}
        fromPhone={fromPhone}
        notes={notes}
        handleSubmit={this.handleSubmit.bind(this)}
        handleSelect={this.handleSelect.bind(this)}
        handleChange={this.handleChange.bind(this)}
        toggleManualPaymentDialog={toggleManualPaymentDialog}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user,
  };
}

export default connect(mapStateToProps, null)(ManualPaymentContainer);



// WEBPACK FOOTER //
// ./src/screens/pending-payments/manual-payment.container.js